// Any component can open the Help & feedback dialog, pre-filled, without prop drilling:
//   openFeedback({ kind: "problem", message: "Setup failed: …", context: { … } })
// The launcher in the layout listens. A plain DOM event so error banners deep in a page, and
// non-React code, can both use it.
export const FEEDBACK_EVENT = "cdt:feedback:open";

export const openFeedback = (detail = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(FEEDBACK_EVENT, { detail }));
};
